import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';

export const ContainerFilter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const ContainerSearch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;


export const ContainerButtons = styled.div`
  display: flex;
  gap: 10px;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 32px 60px;
  gap: 16px;
  width: 90vw;
`;

export const EmptySearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  text-align: center;
  background-color: ${Colors.backgroundColorTable};
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 20px 0;
`;

export const EmptySearchMessage = styled.h4`
  color: ${Colors.primary};
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
`;
